package org.multiplatform.kotfolio.pages.kobweb

import androidx.compose.runtime.*
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.core.Page

@Page("kobweb_api")
@Composable
fun KobWebAPIPage() {
    BlogLayout(
        PageProperties(
            "API Calling",
            ""
        ),
        BlogProperties("Kobweb", "API Calling")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            KotlinCode(
                code = """
                    //Navigation
                    val context = rememberPageContext()
                    context.router.navigateTo("/portfolio/project?id=1")
                    
                    //Get Argument Value
                    val context = rememberPageContext()
                    val hasCategoryParam = remember(key1 = context.route) {
                        context.route.params.containsKey(CATEGORY_PARAM)
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Form Handle
                    
                    @Composable
                    fun PrimaryButton(
                        modifier: Modifier = Modifier,
                        content: @Composable () -> Unit,
                        onSubmit: (SyntheticMouseEvent) -> Unit
                    ) {
                        Button(
                            attrs = PrimaryButtonStyleGradient
                                .toModifier()
                                .primaryButton()
                                .cursor(Cursor.Pointer)
                                .onClick { event -> onSubmit(event) }
                                .then(modifier)
                                .toAttrs(),
                        ) {
                            Span(
                                attrs = Modifier
                                    .classNames("button-gradient")
                                    .primaryButtonGradient()
                                    .zIndex(-1)
                                    .fillMaxSize()
                                    .then(modifier)
                                    .toAttrs()
                            )
                            content()
                        }
                    }
                    
                    @Composable
                    fun ContactForm() {
                        val scope = rememberCoroutineScope()
                        Form(
                            attrs = Modifier
                                .id("contact_form")
                                .fillMaxWidth()
                                .toAttrs()
                        ) {
                            Column(
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                PrimaryButton(
                                    onSubmit = { event ->
                                        event.preventDefault()
                                        val form = (document.getElementById("contact_form") as HTMLFormElement)
                                        if (form.checkValidity()) {
                                            scope.launch {
                                               
                                            }
                                        } else {
                                        
                                        }
                                    },
                                    content = {
                                        SpanText(
                                            modifier = Modifier.fontSize(SUBTITLE_SIZE),
                                            text = "SEND MESSAGE"
                                        )
                                    }
                                )
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        [versions]
                        jetbrains-compose = "1.8.0"
                        kobweb = "0.23.1"
                        kotlin = "2.2.10"
                        kotlinx-serialization-json = "1.9.0"

                         ktor = "2.3.4"

                        #KOIN
                        ksp = "1.8.21-1.0.11"
                        koin-compose-version = "1.0.4"
                        koin = "4.1.0"
                        koinKspVersion = "1.2.2"

                        [libraries]
                        compose-html-core = { module = "org.jetbrains.compose.html:html-core", version.ref = "jetbrains-compose" }
                        compose-runtime = { module = "org.jetbrains.compose.runtime:runtime", version.ref = "jetbrains-compose" }
                        kobweb-api = { module = "com.varabyte.kobweb:kobweb-api", version.ref = "kobweb" }
                        kobweb-core = { module = "com.varabyte.kobweb:kobweb-core ", version.ref = "kobweb" }
                        kobweb-silk = { module = "com.varabyte.kobweb:kobweb-silk", version.ref = "kobweb" }
                        kobweb-worker = { module = "com.varabyte.kobweb:kobweb-worker", version.ref = "kobweb" }
                        kobwebx-markdown = { module = "com.varabyte.kobwebx:kobwebx-markdown", version.ref = "kobweb" }
                        kobwebx-serialization-kotlinx = { module = "com.varabyte.kobwebx:kobwebx-serialization-kotlinx", version.ref = "kobweb" }
                        silk-foundation = { module = "com.varabyte.kobweb:silk-foundation", version.ref = "kobweb" }
                        silk-icons-fa = { module = "com.varabyte.kobwebx:silk-icons-fa", version.ref = "kobweb" }
                        silk-icons-mdi = { module = "com.varabyte.kobwebx:silk-icons-mdi", version.ref = "kobweb" }
                        kotlinx-serialization-json = { module = "org.jetbrains.kotlinx:kotlinx-serialization-json", version.ref = "kotlinx-serialization-json" }
                        ktor-client-core = { module = "io.ktor:ktor-client-core", version.ref = "ktor" }
                        ktor-client-js = { module = "io.ktor:ktor-client-js", version.ref = "ktor" }
                        ktor-client-content-negotiation = { module = "io.ktor:ktor-client-content-negotiation", version.ref = "ktor" }
                        ktor-client-logging = { module = "io.ktor:ktor-client-logging", version.ref = "ktor" }

                        #KOIN
                        koin-core-js = { module = "io.insert-koin:koin-core-js", version.ref = "koin" }
                        koin-core = { module = "io.insert-koin:koin-core", version.ref = "koin" }
                        koin-android = { module = "io.insert-koin:koin-android", version.ref = "koin" }
                        koin-compose = { module = "io.insert-koin:koin-compose", version.ref = "koin-compose-version" }
                        koin-annotations = { module = "io.insert-koin:koin-annotations", version.ref = "koinKspVersion" }
                        koin-ksp = { module = "com.google.devtools.ksp:symbol-processing-api", version.ref = "ksp" }
                        koin-compiler = { module = "io.insert-koin:koin-ksp-compiler", version.ref = "koinKspVersion" }


                        [plugins]
                        jetbrains-compose = { id = "org.jetbrains.compose", version.ref = "jetbrains-compose" }
                        compose-compiler = { id = "org.jetbrains.kotlin.plugin.compose", version.ref = "kotlin" }
                        kobweb-application = { id = "com.varabyte.kobweb.application", version.ref = "kobweb" }
                        kobweb-library = { id = "com.varabyte.kobweb.library", version.ref = "kobweb" }
                        kobweb-worker = { id = "com.varabyte.kobweb.worker", version.ref = "kobweb" }
                        kobwebx-markdown = { id = "com.varabyte.kobwebx.markdown", version.ref = "kobweb" }
                        kotlin-multiplatform = { id = "org.jetbrains.kotlin.multiplatform", version.ref = "kotlin" }
                        kotlinx-serialization = { id = "org.jetbrains.kotlin.plugin.serialization", version.ref = "kotlin" }
                        
                        plugins {
                            alias(libs.plugins.kotlin.multiplatform)
                            alias(libs.plugins.compose.compiler)
                            alias(libs.plugins.kobweb.application)
                            alias(libs.plugins.kobwebx.markdown)
                            alias(libs.plugins.kotlinx.serialization)
                        }
                        
                        
                        kotlin {
                            // This example is frontend only. However, for a fullstack app, you can uncomment the includeServer parameter
                            // and the `jvmMain` source set below.
                            configAsKobwebApplication("multiplatform" /*, includeServer = true*/)

                            sourceSets {
                                commonMain.dependencies {
                                    implementation(libs.kotlinx.serialization.json)
                                    api(libs.koin.core)
                                }

                                jsMain.dependencies {
                                    implementation(libs.kotlinx.serialization.json)

                                    implementation(libs.compose.runtime)
                                    implementation(libs.compose.html.core)
                                    implementation(libs.kobweb.core)
                                    implementation(libs.kobweb.silk)
                                    implementation(libs.silk.icons.fa)
                                    implementation(libs.kobwebx.markdown)

                                    implementation("org.jetbrains.kotlinx:kotlinx-coroutines-core:1.8.0")
                                    implementation("org.jetbrains.kotlinx:kotlinx-coroutines-core-js:1.8.0")
                                    implementation("org.jetbrains.kotlinx:kotlinx-datetime:0.6.0-RC")

                                    // Ktor
                                    implementation(libs.ktor.client.core)
                                    implementation(libs.ktor.client.js)
                                    implementation(libs.ktor.client.content.negotiation)
                                    implementation(libs.ktor.client.logging )
                                    implementation("io.ktor:ktor-serialization-kotlinx-json:2.3.4")

                                    //koin
                                    implementation(libs.koin.core.js)
                                }

                                // Uncomment the following if you pass `includeServer = true` into the `configAsKobwebApplication` call.
                        //        jvmMain.dependencies {
                        //            compileOnly(libs.kobweb.api) // Provided by Kobweb backend at runtime
                        //        }
                            }
                        }

                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        val koinApplication = startKoin {
                            modules(
                                appModule()
                            )
                        }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        //di/AppModule.kt
                        
                        import org.koin.dsl.module

                        fun appModule() = module {
                            includes(
                                networkModule,
                                gatewayModule,
                                useCaseModule
                            )
                        }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        //di/NetworkModule.kt
                        
                        import io.ktor.client.*
                        import io.ktor.client.engine.js.*
                        import io.ktor.client.plugins.HttpTimeout
                        import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
                        import io.ktor.client.plugins.defaultRequest
                        import io.ktor.client.plugins.logging.*
                        import io.ktor.client.request.header
                        import io.ktor.serialization.kotlinx.json.*
                        import kotlinx.serialization.json.Json
                        import org.koin.dsl.module

                        private const val RequestTimeoutMillis = 15_000L

                        val networkModule = module {
                            single {
                                val client = HttpClient(Js) {
                                    install(HttpTimeout) {
                                        requestTimeoutMillis = RequestTimeoutMillis
                                    }

                                    defaultRequest {
                                        header("Content-Type", "application/json")
                                        url("https://dummyjson.com/")
                                    }

                                    install(Logging) {
                                        logger = Logger.DEFAULT
                                        level = LogLevel.ALL
                                        /*filter { request ->
                                            request.url.host.contains("ktor.io")
                                        }*/
                                    }

                                    install(ContentNegotiation) {
                                        json(Json {
                                            prettyPrint = true
                                            isLenient = true
                                            ignoreUnknownKeys = true
                                        })
                                    }
                                }
                                client
                            }
                        }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        //di/UseCaseModule.kt
                        
                        val useCaseModule = module {
                            singleOf(::ProductUseCase) { bind<IProductUseCase>() }
                        }
                    """.trimIndent()
            )

            //domain
            KotlinCode(
                code = """
                        //domain/entity/ProductEntity.kt
                        
                        data class Products(
                            var productlist: List<Product>
                        )

                        data class Product (
                            var id: Int=0,
                            var title: String="",
                            val description: String="",
                            val price: Double=0.0,
                            val discountPercentage: Double=0.0,
                            val category: String="",
                            val thumbnail: String=""
                        )
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                         //domain/getway/IProductGateway.kt
                         
                         interface IProductGateway {
                             suspend fun getProducts(): Products
                         }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                         //domain/usercase/ProductUseCase.kt
                         
                         interface IProductUseCase {
                             suspend fun getBlocks(): Products
                         }

                         class ProductUseCase(private val userGateway: IProductGateway) :
                             IProductUseCase {
                             override suspend fun getBlocks(): Products {
                                 return userGateway.getProducts()
                             }
                         }
                    """.trimIndent()
            )

            //data/remote
            KotlinCode(
                code = """
                        //data/remote/mapper/ProductMapper.kt
                        
                        fun ProductsDto.toEntity(): Products {
                            return Products(
                                productlist = productlist.toEntity()
                            )
                        }

                        fun List<ProductDto>.toEntity() = map { it.toEntity() }

                        fun ProductDto.toEntity() = Product(
                            id = id ,
                             title = title,
                            description = description,
                            price = price,
                        )
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        //data/remote/model/ProductDto.kt
                        
                        @Serializable
                        data class ProductsDto (
                            @SerialName("products")
                           var productlist: List<ProductDto>
                        )

                        @Serializable
                        data class ProductDto (
                            @SerialName("id")
                            var id: Int=0,
                            @SerialName("title")
                            var title: String="",
                            @SerialName("description")
                            val description: String="",
                            @SerialName("price")
                            val price: Double=0.0,
                        ) 
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        //data/remote/model/ServerResponse.kt
                        @Serializable
                        data class ServerResponse<T>(
                            @SerialName("value")
                            val value: T? = null,
                            @SerialName("isSuccess")
                            val isSuccess: Boolean = true,
                            @SerialName("status")
                            val status: ResponseStatus
                        )

                        @Serializable
                        data class ResponseStatus(
                            @SerialName("errorMessages")
                            val errorMessages: Map<String, String>? = null,
                            @SerialName("successMessage")
                            val successMessage: String? = null,
                            @SerialName("code")
                            val code: Int?
                        )
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        //data/remote/BaseGateway.kt
                        
                         abstract class BaseGateway(val client: HttpClient) {
                             suspend inline fun <reified T> tryToExecuteWebSocket(path: String): Flow<T> {
                                 return flow {
                                     client.webSocket(path = path) {
                                         while (true) {
                                             try {
                                                 emit(receiveDeserialized<T>())
                                             } catch (e: Exception) {
                                                 throw Exception(e.message.toString())
                                             }
                                         }
                                     }
                                 }.flowOn(Dispatchers.Main)
                             }

                             suspend inline fun <reified T> tryToExecute(method: HttpClient.() -> HttpResponse): T {
                                     return client.method().body()
                             }
                         }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        //data/remote/ProductGateway.kt
                         
                        class ProductGateway(
                            client: HttpClient,
                        ) : BaseGateway(client), IProductGateway {

                            override suspend fun getProducts(): Products {
                                return tryToExecute<ProductsDto> {
                                    get("products?limit=100&skip=5")
                                }.toEntity()
                            }
                        }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                        //viewmodel
                        class ProjectController(private var iBlog: IBlog, private val productUseCase: IProductUseCase) {
                            private val scope = CoroutineScope(SupervisorJob())
                            
                            //calling api 
                            init {
                                scope.launch {
                                    getData()
                                }
                             }
                                
                            private fun getData() {
                                tryToExecute(
                                    productUseCase::getBlocks,
                                    ::onGetProductListSuccess
                                )
                            }

                            //domain.entity.Products
                            private fun onGetProductListSuccess(products: Products) {
                                println( products.productlist.size)
                            }

                             private fun <T> tryToExecute(
                                function: suspend () -> T,
                                onSuccess: (T) -> Unit,
                                inScope: CoroutineScope = scope,
                            ): Job {
                                return runWithErrorCheck(inScope) {
                                    val result = function()
                                    onSuccess(result)
                                }
                            }

                            private fun runWithErrorCheck(
                                inScope: CoroutineScope = scope,
                                dispatcher: CoroutineDispatcher = Dispatchers.Unconfined,
                                function: suspend () -> Unit,
                            ): Job {
                                return inScope.launch(dispatcher) {
                                    function()
                                }
                            }
                        }
                    """.trimIndent()
            )
        }
    }
}